module.exports = __webpack_public_path__ + "img/masscoms_1.6ff19e6e.png";